import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent, ref } from "vue"; // modules

import POSConfigModule from "@/store/modules/pos-config";
import PrinterConfigModule from "@/store/modules/printers-config"; // helpers

import { dialogVisibleForStatus, hideDialog } from "@/utils/vue-helpers/modal"; // constants

import { ModalStatus } from "@/constants/modal";
import { PaymentMethodTypes } from "@/types/db/pos-config";
import DeviceModule from "@/store/modules/device";
import { computed } from "@vue/reactivity";
import { LogLevel, LogService } from "@/services/logging";
import ScanSettings from "@/components/modal/settings/ScanSettings.vue";
import TerminalsStatus from "@/components/modal/settings/TerminalsStatus.vue";
import { setDeviceLocation } from "@/api/device/device";
import NotificationService from "@/services/notification.service";
import { getDeviceLocation } from "@/api/gql/device";
export default defineComponent({
  name: "Settings",
  components: {
    ScanSettings: ScanSettings,
    TerminalsStatus: TerminalsStatus
  },
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var modalVisibility, isLoading, settingsPaymentMethods, ticketsEmails, scanSettings, deviceSettings, DeviceLocationSettings, CompleteWithBalanceSettings, cashDrawerSettings, cardPaymentMethod, hasHardwareInfo, canSave, onSave;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              modalVisibility = dialogVisibleForStatus(ModalStatus.Settings);
              isLoading = ref(false);
              settingsPaymentMethods = ref();
              ticketsEmails = ref();
              scanSettings = ref();
              deviceSettings = ref();
              DeviceLocationSettings = ref();
              CompleteWithBalanceSettings = ref();
              cashDrawerSettings = ref();
              cardPaymentMethod = computed(function () {
                var _settingsPaymentMetho;

                return (_settingsPaymentMetho = settingsPaymentMethods.value) === null || _settingsPaymentMetho === void 0 ? void 0 : _settingsPaymentMetho.settingsData.find(function (elm) {
                  return elm.id === PaymentMethodTypes.CardAuto;
                });
              });
              hasHardwareInfo = computed(function () {
                // If there is no hardware info (user using a browser) we don't show device settings
                if (DeviceModule.hardwareInfo) {
                  return true;
                } else {
                  return false;
                }
              });
              canSave = computed(function () {
                return !cardPaymentMethod.value || !cardPaymentMethod.value.used || cardPaymentMethod.value.used && cardPaymentMethod.value.terminal;
              });

              onSave = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var _settingsPaymentMetho2, _ticketsEmails$value, _DeviceLocationSettin;

                  var paymentConfig, paymentFormData, printerOption, deviceId, cardPaymentMethod, selectedDevice, stats, hardwareUid, _deviceId, fiskalyCashRegisterId, name, status, groupId, resp, device, _deviceSettings$value, Id, _device;

                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          isLoading.value = true;
                          paymentConfig = {};
                          paymentFormData = ((_settingsPaymentMetho2 = settingsPaymentMethods.value) === null || _settingsPaymentMetho2 === void 0 ? void 0 : _settingsPaymentMetho2.settingsData) || [];
                          LogService.info("User confirmed attached settings updates", {
                            paymentFormData: paymentFormData.value
                          });
                          printerOption = (_ticketsEmails$value = ticketsEmails.value) === null || _ticketsEmails$value === void 0 ? void 0 : _ticketsEmails$value.printerOption; // const deviceId: number = deviceSettings.value?.deviceId as number;

                          deviceId = (_DeviceLocationSettin = DeviceLocationSettings.value) === null || _DeviceLocationSettin === void 0 ? void 0 : _DeviceLocationSettin.deviceId;
                          cardPaymentMethod = paymentFormData.find(function (elm) {
                            return elm.id === PaymentMethodTypes.CardAuto;
                          }); // Check if the user didn't select a terminal then disable Card payment method

                          if (!cardPaymentMethod.terminal) cardPaymentMethod.used = false;
                          paymentFormData.map(function (item) {
                            var _item$id = item.id,
                                id = _item$id === void 0 ? PaymentMethodTypes.Cash : _item$id,
                                _item$used = item.used,
                                used = _item$used === void 0 ? true : _item$used,
                                _item$currency = item.currency,
                                currency = _item$currency === void 0 ? null : _item$currency,
                                _item$paymentMethods = item.paymentMethods,
                                paymentMethods = _item$paymentMethods === void 0 ? null : _item$paymentMethods,
                                _item$terminal = item.terminal,
                                terminal = _item$terminal === void 0 ? null : _item$terminal;

                            if (terminal) {
                              paymentConfig.terminal = terminal;
                            }

                            paymentConfig[id] = _objectSpread(_objectSpread(_objectSpread({
                              used: used
                            }, currency && {
                              acceptedCurrencies: currency
                            }), paymentMethods && {
                              paymentMethods: paymentMethods
                            }), id === PaymentMethodTypes.CardAuto && {
                              processor: "ADYEN"
                            });
                          }); // If we have a hardware and no location for the device, and a device selected by the user
                          // we should patch device so that backend will attach this hardware to a device with location in backend
                          // If we don't even have a hardware info it means we're in a browser, we will keep old logic

                          if (!(DeviceModule.hardwareInfo && !DeviceModule.isOldDeviceLogic)) {
                            _context.next = 47;
                            break;
                          }

                          if (DeviceModule.hardwareLocation) {
                            _context.next = 45;
                            break;
                          }

                          // so this hardware is being used for the first time and user wants to assign it to
                          // a device with location in backend
                          LogService.info("App running on device with hardwareInfo but no location linked.");
                          console.log("going to link this hardware to  a device with location in backend"); // going to link this hardware to  a device with location in backend
                          // lets prepare the payload

                          selectedDevice = DeviceModule.devices.find(function (device) {
                            return device.id === deviceId;
                          }); // console.log("selectedDevice");
                          // console.log(selectedDevice);

                          if (!selectedDevice) {
                            _context.next = 45;
                            break;
                          }

                          stats = null; // TODO Hamza: Ask Saoussene what this is. I found it in POSTman

                          hardwareUid = DeviceModule.hardwareInfo.id;
                          _deviceId = selectedDevice.id;
                          fiskalyCashRegisterId = selectedDevice.fiskalyCashRegisterId;
                          name = selectedDevice.name;
                          status = 1;
                          groupId = POSConfigModule.groupId;
                          LogService.info("Going to link the device to location in backend using PATCH device payload attached.", {
                            params: {
                              stats: stats,
                              hardwareUid: hardwareUid,
                              fiskalyCashRegisterId: String(fiskalyCashRegisterId),
                              name: String(name),
                              status: status,
                              groupId: Number(groupId),
                              deviceId: Number(_deviceId)
                            }
                          });
                          _context.prev = 23;
                          _context.next = 26;
                          return setDeviceLocation({
                            stats: stats,
                            hardwareUid: hardwareUid,
                            fiskalyCashRegisterId: String(fiskalyCashRegisterId),
                            name: String(name),
                            status: status,
                            groupId: Number(groupId),
                            deviceId: Number(_deviceId)
                          });

                        case 26:
                          resp = _context.sent;
                          LogService.info("Device is now linked to location in backend, response attached.", {
                            params: resp
                          }); // console.log("resp");
                          // console.log(resp);
                          // Lets set the location assigned with this hardware to the state
                          // DeviceModule.setHardwareLocation({
                          //   name: resp.name,
                          //   id: resp.id,
                          // });

                          if (!resp) {
                            _context.next = 36;
                            break;
                          }

                          _context.next = 31;
                          return getDeviceLocation(
                          /*"decommision_device"*/
                          hardwareUid);

                        case 31:
                          device = _context.sent;
                          LogService.info("Device location pulled from backend backend (attached). HardwareUid: ".concat(hardwareUid), {
                            params: device
                          });
                          console.log("device");
                          console.log(device); // If we get a device with a location, then we set the location to the state
                          // and in the settings popup we show a disabled dropdown showning the current device
                          // this location will be later used for Cash in and Cash out

                          if (device && device.length) {
                            if (device[0].locationId) {
                              DeviceModule.setHardwareLocation({
                                locationId: device[0].locationId,
                                deviceName: String(device[0].name),
                                deviceId: Number(device[0].id),
                                deviceUid: String(device[0].deviceUid),
                                FiskalyCashRegisterId: device[0].fiskalyCashRegisterId || ""
                              });
                            } else {
                              NotificationService.showCustomError("Error when setting the hardware");
                            }
                          } else {
                            // if we get no device or we get a device without location then we pull all devices from backend
                            // and in the settings popup we show a dropdown with all the devices for the user to select one of them
                            // and once he submits his selection we call the api created by Saoussene and we supply the hardwareUuid
                            // we will do it in DeviceLocationSettings component
                            // LogService.info(
                            //   `Device isn't linked to a location in backend. Going to fetch devices from backend. HardwareUid: ${hardwareUid}`
                            // );
                            // await DeviceModule.fetchDevices();
                            NotificationService.showCustomError("Error when setting the hardware");
                          } /////


                        case 36:
                          _context.next = 45;
                          break;

                        case 38:
                          _context.prev = 38;
                          _context.t0 = _context["catch"](23);
                          // TODO HAMZA: here we show an error message based on what we had in the response
                          console.log("err");
                          console.log(_context.t0);
                          LogService.info("Error when linking device to location in backend.", {
                            params: _context.t0
                          }, LogLevel.Error);
                          NotificationService.showCustomError("Error when setting the hardware"); // we don't close the popup

                          return _context.abrupt("return");

                        case 45:
                          _context.next = 51;
                          break;

                        case 47:
                          // App is running without hardware info. Going to set a device selected by the user in old way (no location logic and no backend)
                          // find device in devices array using deviceId
                          Id = (_deviceSettings$value = deviceSettings.value) === null || _deviceSettings$value === void 0 ? void 0 : _deviceSettings$value.deviceId;
                          _device = DeviceModule.devices.find(function (device) {
                            return device.id === Id;
                          });
                          LogService.info("App is running without hardware info. Going to set a device selected by the user (attached) in old way (no location logic and no backend)", {
                            params: _device
                          });

                          if (_device) {
                            // Save device info
                            DeviceModule.setDeviceInfo(_device);
                          }

                        case 51:
                          // Save printer options
                          PrinterConfigModule.setPrinterOption(printerOption);
                          POSConfigModule.postPaymentMethods(paymentConfig);
                          POSConfigModule.setPaymentSettings(paymentFormData); // whether to allow completing unpaid/partially paid bookings or not

                          POSConfigModule.setCompleteBookingWithBalance(CompleteWithBalanceSettings.value.status); // Save selected ticket type

                          PrinterConfigModule.setTicketType(ticketsEmails.value.selectedTicketType); // save label printing status (enabled/disabled)

                          PrinterConfigModule.setIsLabelPrintingEnabled(ticketsEmails.value.labelPrintingStatus); // save the selected label printer

                          if (ticketsEmails.value.labelPrinter) {
                            PrinterConfigModule.setLabelPrinter(ticketsEmails.value.labelPrinter);
                          } // save the selected ticket printer


                          if (ticketsEmails.value.ticketPrinter) {
                            PrinterConfigModule.setTicketPrinter(ticketsEmails.value.ticketPrinter);
                          } // save ticket printing status (enabled/disabled)


                          PrinterConfigModule.setIsTicketPrintingEnabled(ticketsEmails.value.ticketPrintingStatus); // save auto print receipt status (auto/manual)

                          PrinterConfigModule.setAutoPrintReceipt(cashDrawerSettings.value.autoPrintReceipt || false);
                          POSConfigModule.setOpenCashDrawer(cashDrawerSettings.value.selectedOption);
                          POSConfigModule.setAutoScanTickets(scanSettings.value.autoScanTickets);
                          setTimeout(function () {
                            isLoading.value = false;
                            hideDialog();
                          }, 500);

                        case 64:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[23, 38]]);
                }));

                return function onSave() {
                  return _ref.apply(this, arguments);
                };
              }();

              return _context2.abrupt("return", {
                modalVisibility: modalVisibility,
                isLoading: isLoading,
                settingsPaymentMethods: settingsPaymentMethods,
                ticketsEmails: ticketsEmails,
                deviceSettings: deviceSettings,
                DeviceLocationSettings: DeviceLocationSettings,
                TerminalsStatus: TerminalsStatus,
                hideDialog: hideDialog,
                onSave: onSave,
                canSave: canSave,
                CompleteWithBalanceSettings: CompleteWithBalanceSettings,
                cashDrawerSettings: cashDrawerSettings,
                scanSettings: scanSettings,
                hasHardwareInfo: hasHardwareInfo,
                DeviceModule: DeviceModule
              });

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});